import { useMemo } from "react";
import { isDev, isLocal, isQA } from "@cores/enviromentExtension";
import { ASSET_THUMBNAIL_CARD_CONTAINER_SIZE, ASSET_THUMBNAIL_TABLE_CONTAINER_SIZE } from "@constants";
import useSettings from "@hooks/useSettings";
import theme from "@styles/theme";

const useThumbnailCrop = ({ variant, ignorePadding, thumbnailCrop, cardContainerSize, tableContainerSize }) => {
    const containerPadding = useMemo(() => {
        if (ignorePadding) return 0;
        return variant !== "table" ? 12 : 0;
    }, []);

    const previewContainerStyle = useMemo(() => {
        return thumbnailCrop
            ? {
                  width: `calc(100% - ${containerPadding * 2}px)`,
                  height: `calc(100% - ${containerPadding * 2}px)`,
                  overflow: "hidden",
                  position: "relative",
                  padding: `${containerPadding}px`,
                  borderRadius: theme.spacing(0.5),
              }
            : {
                  width: "100%",
                  height: "100%",
                  padding: `${containerPadding}px`,
                  borderRadius: theme.spacing(0.5),
                  overflow: "hidden",
              };
    }, [thumbnailCrop]);

    const previewImageStyle = useMemo(() => {
        const scale = Math.ceil(1000 * (tableContainerSize / (cardContainerSize - containerPadding * 2))) / 1000;

        return thumbnailCrop
            ? {
                  position: "absolute",
                  width: "auto",
                  height: "auto",
                  left: "50%",
                  top: "50%",
                  transform: `translate(-50%,-50%) ${variant === "card" ? "" : `scale(${scale})`}`,
              }
            : {
                  objectFit: "contain",
                  width: `100%`,
                  height: `100%`,
              };
    }, [thumbnailCrop]);

    return { previewContainerStyle, previewImageStyle };
};

export default useThumbnailCrop;
